import "./App.scss";

import HomePage from "./Components/Home/HomePage";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { lazy, Suspense } from "react";
import Loader from "./Utils/Loader";
import ScrollToTop from "./Utils/utils";
import ErrorElement from "./Components/Error/Error";
import ErrorElementAdm from "./Components/Admin/Error/Error";
import NavAndFooter from "./Utils/HeaderAndNav";
import Services, { fetchServiceLoader } from "./Components/Services/Services";
import AdminAddService from "./Components/Admin/Settings/AdminAddService/AdminAddService";
import AdminLogin from "./Components/Admin/Login/Login";

import { portfolioLoader } from "./Components/Portfolio/Portfolio";
import AddAdmin from "./Components/Admin/Settings/AddAdmin/AddAdmin";
import { HelmetProvider } from "react-helmet-async";

//Lazy imports
const About = lazy(() => import("./Components/About/About"));
const Portfolio = lazy(() => import("./Components/Portfolio/Portfolio"));
const Blogs = lazy(() => import("./Components/Blogs/Blogs"));
const Contact = lazy(() => import("./Components/Contact/Contact"));
const AdminDashboard = lazy(
  () => import("./Components/Admin/Dashboard/Dashboard"),
);
const Messages = lazy(() => import("./Components/Admin/Messages/Messages"));
const AdminPage = lazy(() => import("./Components/Admin/Admin"));
const AddNewsForm = lazy(() => import("./Components/AddNewsForm/AddNewsForm"));
const AdminReviewPosts = lazy(
  () => import("./Components/Admin/AdminReviewPosts/AdminReviewPosts"),
);
const AdminSettingsPage = lazy(
  () => import("./Components/Admin/Settings/Settings"),
);

function App() {
  const routes = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          path="/"
          element={
            <>
              <ScrollToTop />
              <NavAndFooter />
            </>
          }
          errorElement={<ErrorElement />}
        >
          <Route index element={<HomePage />} />
          <Route
            path="about"
            element={
              <Suspense fallback={<Loader />}>
                <About />
              </Suspense>
            }
          />
          <Route
            path="blog"
            element={
              <Suspense fallback={<Loader />}>
                <Blogs />
              </Suspense>
            }
          />
          <Route
            path="login"
            element={
              <Suspense fallback={<Loader />}>
                <h1>LOGIN...</h1>
              </Suspense>
            }
          />
          <Route
            path="add"
            element={
              <Suspense fallback={<Loader />}>
                <AddNewsForm />
              </Suspense>
            }
          />
          <Route
            path="contact"
            element={
              <Suspense fallback={<Loader />}>
                <Contact />
              </Suspense>
            }
          />
          <Route
            path="portfolio"
            loader={portfolioLoader}
            element={
              <Suspense fallback={<Loader />}>
                <Portfolio />
              </Suspense>
            }
          />
          <Route
            path="/services/:title"
            loader={fetchServiceLoader}
            element={
              <Suspense fallback={<Loader />}>
                <Services />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="admin"
          errorElement={<ErrorElementAdm />}
          element={
            <Suspense fallback={<Loader />}>
              <AdminPage />
            </Suspense>
          }
        >
          <Route
            index
            element={
              <Suspense fallback={<Loader />}>
                <AdminDashboard />
              </Suspense>
            }
          />
          <Route
            path="posts"
            element={
              <Suspense fallback={<Loader />}>
                <AdminReviewPosts />
              </Suspense>
            }
          />
          <Route
            path="messages"
            element={
              <Suspense fallback={<Loader />}>
                <Messages />
              </Suspense>
            }
          />
          <Route path="add-user" element={<AddAdmin />} />
          <Route
            path="settings"
            element={
              <Suspense fallback={<Loader />}>
                <AdminSettingsPage />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="/admin/add-services"
          element={
            <Suspense fallback={<Loader />}>
              <AdminAddService />
            </Suspense>
          }
        />
        <Route
          path="/admin/login"
          element={
            <Suspense fallback={<Loader />}>
              <AdminLogin />
            </Suspense>
          }
        />

        <Route path="*" element={<HomePage />} />
      </>,
    ),
  );
  return (
    <div className="App">
      <HelmetProvider>
        <RouterProvider router={routes} />
      </HelmetProvider>
    </div>
  );
}

export default App;
